import {ChatMessage, ChatMessageType} from "./types";

export enum ChatItemViewContainer {
  MESSAGE,
  TRANSPARENT,
  MESSAGE_TRANSPARENT,
  MESSAGE_STATE,
}

export enum ChatItemViewUnavailable {
  NONE,
  UNKNOWN,
  EXPIRED,
  DELETED,
}

export enum ChatItemViewFrom {
  ME,
  OTHER,
}

export enum ChatItemViewMessageMimetype {
  OTHER,
  TEXT,
  IMAGE,
  AUDIO,
  VIDEO
}

export type ChatItemViewType = {
  container: ChatItemViewContainer,
  unavailable: ChatItemViewUnavailable,
  from: ChatItemViewFrom,
  mimetype: ChatItemViewMessageMimetype,
}

export class ChatUtil {

  static getItemViewType(message: ChatMessage, me: string): ChatItemViewType {
    let container: ChatItemViewContainer;
    let unavailable: ChatItemViewUnavailable;
    let from: ChatItemViewFrom;
    let mimetype: ChatItemViewMessageMimetype;
    switch (message.type) {
      case ChatMessageType.TEXT:
        container = ChatItemViewContainer.MESSAGE;
        unavailable = ChatUtil.messageUnavailable(message);
        from = message.from.id === me ? ChatItemViewFrom.ME : ChatItemViewFrom.OTHER;
        mimetype = ChatItemViewMessageMimetype.TEXT;
        break;
      case ChatMessageType.META:
        container = ChatItemViewContainer.TRANSPARENT;
        unavailable = ChatUtil.messageUnavailable(message);
        from = ChatItemViewFrom.OTHER;
        mimetype = ChatItemViewMessageMimetype.TEXT;
        break;
      case ChatMessageType.CALL:
        container = ChatItemViewContainer.MESSAGE;
        unavailable = ChatUtil.messageUnavailable(message);
        from = message.from.id === me ? ChatItemViewFrom.ME : ChatItemViewFrom.OTHER;
        mimetype = ChatItemViewMessageMimetype.TEXT;
        break;
      default:
        container = ChatItemViewContainer.MESSAGE;
        from = message.from.id === me ? ChatItemViewFrom.ME : ChatItemViewFrom.OTHER;
        unavailable = ChatItemViewUnavailable.UNKNOWN;
        mimetype = ChatItemViewMessageMimetype.OTHER;
        break;
    }
    return {
      container,
      unavailable,
      from,
      mimetype
    };
  }

  static messageAvailable(message: ChatMessage): boolean {
    return this.messageUnavailable(message) === ChatItemViewUnavailable.NONE;
  }

  static messageUnavailable(message: ChatMessage): ChatItemViewUnavailable {
    if (message) {
      if (message.deleted) {
        return ChatItemViewUnavailable.DELETED;
      } else if (message.isExpired()) {
        return ChatItemViewUnavailable.EXPIRED;
      }
    }
    return ChatItemViewUnavailable.NONE;
  }
}
